import React from 'react';
import { T, useTranslate } from 'shared/helper/translate';
import DropdownActionsMenu from 'researcher/components/DropdownActionsMenu';
import { getApiBaseUrl } from 'shared/helper/request';
import PaddleCancelFapiaoLink from './PaddleCancelFapiaoLink';
var PaddleActionsDropdown = function PaddleActionsDropdown(_ref) {
  var onFapiaoCancelled = _ref.onFapiaoCancelled,
    order = _ref.order;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  return /*#__PURE__*/React.createElement(DropdownActionsMenu, {
    render: function render(_ref2) {
      var dismissDropdown = _ref2.dismissDropdown;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PaddleCancelFapiaoLink, {
        fapiao: order === null || order === void 0 ? void 0 : order.fapiao,
        onFapiaoCancelled: onFapiaoCancelled
      }), /*#__PURE__*/React.createElement("a", {
        "aria-label": t('get-support'),
        className: "d-block m-1 p-2",
        href: "".concat(getApiBaseUrl(), "/support"),
        target: "_blank",
        onClick: dismissDropdown,
        rel: "noreferrer"
      }, /*#__PURE__*/React.createElement(T, {
        source: "get-support"
      })));
    }
  });
};
export default PaddleActionsDropdown;